<template>
  <el-form-item
    :label="$attrs.label"
    :prop="$attrs.name"
    class="elsa-input"
    ref="search"
  >
    <el-input
      v-bind="$attrs"
      v-model="modelProp"
      @input="addBorder"
      @focus="addBorder"
      @change="removeBorder"
      :placeholder="$t('common.search')"
    >
      <template #append>
        <button @click="searchBy"><i class="el-icon-search"/></button>
      </template>
    </el-input>
  </el-form-item>
</template>

<script>
export default {
  name: "ElsaSearch",
  props: ['value'],
  computed: {
    modelProp: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
    }
  },
  methods: {
    addBorder() {
      const searchInput = this.$refs.search.$el
      searchInput.classList.add('on-focus')
    },
    removeBorder() {
      const searchInput = this.$refs.search.$el
      searchInput.classList.remove('on-focus')
    },
    searchBy(event) {
      event.preventDefault()
      this.$emit('search', this.modelProp)
    },
    resetSearch() {
      this.modelProp = ''
      this.$emit('search', '')
    }
  },
}
</script>

<style lang="scss" scoped>
  @import '../../../scss/colors';
  .el-input {
    border: 1px solid $light-blue;
    border-radius: 8px;
    height: 50px;
  }

  ::v-deep .el-input-group__append {
    align-items: center;
    display: flex;
    justify-content: center;
    background-color: white;
    border: none;
  }

  button {
    border: none;
    background-color: #ffffff00;
    cursor: pointer;
    &:focus {
      outline: none;
    }
  }

  i {
    margin-right: 10px;
    cursor: pointer;
    font-size: 15px;
    color: $black;
    font-weight: 900;
  }

  .on-focus .el-input {
    border: 2px solid $purple;
  }

  .elsa-input::v-deep .el-input .el-input__inner {
    border: none !important;
  }

</style>
